module.exports = "https://web-assets.ifttt.com/packs/media/social-signon/apple-b3e5c3f4.svg";